import { render, staticRenderFns } from "./CreateProductVariantModal.vue?vue&type=template&id=573b4f24&"
import script from "./CreateProductVariantModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductVariantModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductVariantModal.vue?vue&type=style&index=0&id=573b4f24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports